import React, { Component } from 'react';
import MerchantSelectorList from './MerchantSelectorList/MerchantSelectorList';
import PropTypes from 'prop-types';
import { merchantShape } from '../../../utils/propTypes';
import { connect } from 'react-redux';
import {
    getIsSelectorOpen,
    getSelectedMerchants
} from '../merchantSelectorViewState';
import {
    toggleSelectorOpen,
    updateSelectedMerchants
} from '../merchantSelectorActions';
import enhanceWithClickOutside from '../../../utils/enhanceWithClickOutside';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import classNames from 'classnames';
import './Popup.scss';
import {  getMerchants as getMerchantsFromPayment } from '../../MerchantManagement/merchantManagementEntity.js';
import { getMerchants as getMerchantsFetch } from '../../MerchantManagement/merchantManagementActions.js';
import _ from 'lodash';
import { getMerchants } from '../../Merchants/merchantsEntity';

export class Popup extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        onToggleSelectorOpen: PropTypes.func.isRequired,
        onUpdateSelectedMerchants: PropTypes.func.isRequired,
        selectedMerchants: PropTypes.arrayOf(merchantShape),
        merchants: PropTypes.arrayOf(merchantShape),
        paymentServiceMerchant: PropTypes.any,
        onGetMerchants: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            animateOpen: false
        };

        this.selectorRef = React.createRef();
    }

    componentDidUpdate(prevProps) {

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isOpen') && this.props.merchants.length) {
            this.setState({
                selectorAreaWidth: this.selectorRef.current.getBoundingClientRect().width
            });
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isOpen')) {
            this.setState({ animateOpen: this.props.isOpen });
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'merchants')) {
            if (_.find(this.props.merchants, { isPaymentConfigured: true })) {
                this.props.onGetMerchants();
            }
        }
    }

    handleClickOutside() {
        if (this.props.isOpen) {
            this.props.onToggleSelectorOpen();
        }
    }

    render() {
        const divStyle = {
            width: this.state.selectorAreaWidth + 'px'
        };

        return (
            <div className={classNames('emvio-merchant-selector-popup', {
                'animate-open': this.state.animateOpen
            })}>
                <div style={this.state.selectorAreaWidth ? divStyle : {}} className="selector-area" ref={this.selectorRef}>
                    <span
                        className="icon-close"
                        onClick={this.props.onToggleSelectorOpen}
                    />
                    <div className="content-wrapper">
                        <MerchantSelectorList
                            {...this.props}
                        />
                    </div>
                </div>
                <div className="selector-background" onClick={this.props.onToggleSelectorOpen}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isOpen: getIsSelectorOpen(state),
        merchants: getMerchants(state),
        selectedMerchants: getSelectedMerchants(state),
        paymentServiceMerchants: getMerchantsFromPayment(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetMerchants: () => dispatch(getMerchantsFetch({}, 0, 100)),
        onToggleSelectorOpen: () => dispatch(toggleSelectorOpen()),
        onUpdateSelectedMerchants: (merchants, isAllSelected) => dispatch(updateSelectedMerchants(merchants, isAllSelected))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(Popup));
